import { arabAliBrand, arabAliMenuSections } from './arabAliMenu';
import type { MediaAsset, MenuCategory, MenuItem, RestaurantWorkspace } from '../types/workspace';
import { slugify } from '../utils/slugify';
import {
  DEFAULT_BACKGROUND_STYLE,
  DEFAULT_BRAND_COLORS,
  DEFAULT_BUTTON_STYLE,
  DEFAULT_CALL_TO_ACTION_LABEL,
  DEFAULT_CURRENCY_CODE,
  DEFAULT_CURRENCY_SYMBOL,
  DEFAULT_FAVICON_IMAGE,
  DEFAULT_LOGO_IMAGE,
  DEFAULT_MAPS_URL,
} from '../utils/restaurantBranding';

const timestamp = '2026-03-13T00:00:00.000Z';

const createAssetId = (prefix: string, value: string) => `${prefix}-${slugify(value)}`;

const defaultHomepageIntro =
  'Browse breakfast, Arabian foods, beef, burgers, pasta, pizza, juice, hot drinks, and soft drinks from the hotel menu. The owner can keep this digital menu updated from the admin workspace.';

export const seedWorkspace: RestaurantWorkspace = {
  settings: {
    name: arabAliBrand.name,
    subtitle: arabAliBrand.subtitle,
    homepageIntro: defaultHomepageIntro,
    location: arabAliBrand.location,
    phoneNumber: arabAliBrand.phoneNumber,
    coverImage: arabAliBrand.coverImage,
    menuUrl: arabAliBrand.menuUrl,
    logoImage: DEFAULT_LOGO_IMAGE,
    faviconImage: DEFAULT_FAVICON_IMAGE,
    currencyCode: DEFAULT_CURRENCY_CODE,
    currencySymbol: DEFAULT_CURRENCY_SYMBOL,
    callToActionLabel: DEFAULT_CALL_TO_ACTION_LABEL,
    mapsUrl: DEFAULT_MAPS_URL,
    brandColors: DEFAULT_BRAND_COLORS,
    backgroundStyle: DEFAULT_BACKGROUND_STYLE,
    buttonStyle: DEFAULT_BUTTON_STYLE,
  },
  categories: arabAliMenuSections.map<MenuCategory>((section, index) => ({
    id: section.id,
    title: section.title,
    slug: slugify(section.title),
    shortDescription: section.shortDescription,
    coverImage: section.coverImage,
    sortOrder: index,
    isVisible: true,
  })),
  items: arabAliMenuSections.flatMap<MenuItem>((section) =>
    section.items.map((item, index) => ({
      id: item.id,
      categoryId: section.id,
      name: item.name,
      slug: slugify(item.name),
      price: item.price,
      description: item.description ?? '',
      imageUrl: '',
      imageAlt: '',
      sortOrder: index,
      isAvailable: true,
      isVisible: true,
    })),
  ),
  mediaAssets: [
    {
      id: createAssetId('restaurant-cover', arabAliBrand.name),
      url: arabAliBrand.coverImage,
      storagePath: arabAliBrand.coverImage,
      altText: `${arabAliBrand.name} cover image`,
      kind: 'restaurant-cover',
      createdAt: timestamp,
    },
    ...arabAliMenuSections.map<MediaAsset>((section) => ({
      id: createAssetId('category-cover', section.id),
      url: section.coverImage,
      storagePath: section.coverImage,
      altText: `${section.title} category cover`,
      kind: 'category-cover',
      createdAt: timestamp,
    })),
  ],
};
